import React, { VoidFunctionComponent, useEffect } from "react";
import dynamic from "next/dynamic";
import { useDispatch } from "react-redux";
import { MKPAvailabilityPlaceholder } from "@/components/responsive/product/availability/availabilityPlaceholder/MKPAvailabilityPlaceholder";
import { AvailabilityPlaceholder } from "@/components/responsive/product/availability/availabilityPlaceholder/AvailabilityPlaceholder";
import { ShippingContextList } from '@/models/scope/shipping/ShippingContextList';
import { MarketplaceState } from "@/models/appState/MarketplaceState";
import { fetchProductAvailabilities } from "@/redux/reducers/responsive/product/productAvailabilityActions";
import { synchronizeShopCircle } from "@/redux/reducers/responsive/header/headerActions";

const DynamicMKPAvailability = dynamic(
    () => import('@/components/responsive/product/mkpAvailability/MkpAvailability'),
    { ssr: false }
);
const DynamicButAvailability = dynamic(
    () => import("@/components/responsive/product/availability/butAvailability/ButAvailability"),
    { ssr: false }
);

interface Props {
    marketplaceData: MarketplaceState
    shopCircleVersion: string
    productId: string
    isFullMkp: boolean
    isAvailabilityPlaceholderShown: boolean
    isMkpAvailabilityPlaceholderShown: boolean
    handleClick: (layerType: string, selectedProductId?: string) => void;
}

const Availability: VoidFunctionComponent<Props> = ({
    productId,
    shopCircleVersion,
    marketplaceData,
    isFullMkp,
    isMkpAvailabilityPlaceholderShown,
    isAvailabilityPlaceholderShown,
    handleClick,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isFullMkp) {
            synchronizeShopCircle(shopCircleVersion).then(() => {
                dispatch(fetchProductAvailabilities(
                    {
                        allShops: false,
                        productId,
                    },
                    ShippingContextList.PRODUCT_SHEET,
                ))
            })
        }
    }, []);

    return (
        isFullMkp ? (
            isMkpAvailabilityPlaceholderShown ? (
                <MKPAvailabilityPlaceholder />
            ) : (
                <DynamicMKPAvailability
                    allowedDeliveryModes={marketplaceData?.offersData?.items?.[0]?.allowedDeliveryModes || []}
                    isLayer={false}
                />
            )
        ) : (
            isAvailabilityPlaceholderShown ? (
                <AvailabilityPlaceholder />
            ) : (
                <DynamicButAvailability
                    handleClick={handleClick}
                    productId={productId}
                />
            )
        )
    );
};

export default Availability;